module.exports = __webpack_public_path__ + "img/empty-background.2e509f8e.svg";